import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å»é¢éç½®
 */
@JsonObject
export class TenantConfig {
  /**
   * ä¸»é®ID
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * è¯¾æ¶è¯¾ä»¶ä¸­çç´ ææ¯å¦åè®¸ä¸è½½ï¼é»è®¤åè®¸ï¼
   */
  @JsonProperty('downloadFileNodeOfCourseware', Boolean)
  downloadFileNodeOfCourseware: boolean = undefined;

  /**
   * åè®¸ç§å®¤ç®¡çååå¸âå¬å¼å°å¨é¢âçæ´»å¨ï¼é»è®¤åè®¸ï¼
   */
  @JsonProperty('publishActivityToTenant', Boolean)
  publishActivityToTenant: boolean = undefined;

  /**
   * åå¸æ´»å¨æ¶ï¼åè®¸ç§å®¤ç®¡çåç­éæéå¤äººå
   */
  @JsonProperty('publishToTenantUser', Boolean)
  publishToTenantUser: boolean = undefined;

  /**
   * åäº«ç»è®¡æ¶ï¼åè®¸ç§å®¤ç®¡çåéæ©æéå¤èå´
   */
  @JsonProperty('shareToTenantDeptOrGroups', Boolean)
  shareToTenantDeptOrGroups: boolean = undefined;

  /**
   * åè®¸ç§å®¤ç®¡çåæ·»å æªè®¤è¯äººåï¼é»è®¤åè®¸ï¼
   */
  @JsonProperty('addUncertifiedUserByAdmin', Boolean)
  addUncertifiedUserByAdmin: boolean = undefined;

  /**
   * åè®¸ç¨æ·ç¼è¾èä½ä¿¡æ¯
   */
  @JsonProperty('userModifyPositionSelf', Boolean)
  userModifyPositionSelf: boolean = undefined;

  /**
   * ç»å½æ¶å¿é¡»å¹éä¸ªäººå¾®ä¿¡è´¦å·
   */
  @JsonProperty('loginUnderWechatAppId', Boolean)
  loginUnderWechatAppId: boolean = undefined;

  /**
   * æ¯å¦å¼å¯åå
   */
  @JsonProperty('openMall', Boolean)
  openMall: boolean = undefined;

  /**
   * ååä¸æ¶æ¯å¦éè¦å®¡æ ¸
   */
  @JsonProperty('onSaleReview', Boolean)
  onSaleReview: boolean = undefined;

  /**
   * æ¯å¦åè®¸å®ä¹ çæ¥çè¯ä»·
   */
  @JsonProperty('allowTraineeViewEvaluation', Boolean)
  allowTraineeViewEvaluation: boolean = undefined;

  /**
   * æ¯å¦åè®¸è§å¹æ¤å£«æ¥çè¯ä»·
   */
  @JsonProperty('allowNewNurseViewEvaluation', Boolean)
  allowNewNurseViewEvaluation: boolean = undefined;

  /**
   * æ¯å¦åè®¸å®ä¹ çåæ´ç§å®¤
   */
  @JsonProperty('allowTraineeChangeDept', Boolean)
  allowTraineeChangeDept: boolean = undefined;

  /**
   * æ¯å¦åè®¸è§å¹æ¤å£«åæ´ç§å®¤
   */
  @JsonProperty('allowNewNurseChangeDept', Boolean)
  allowNewNurseChangeDept: boolean = undefined;
}
